// import { onFetchAsync } from '@scayle/storefront-nuxt'
// import { useRxProducts } from '../useRxProducts'

const useRxFreeServiceProduct = () => {
  const { rxFreeServiceProduct } = useRxProducts()

  // // onFetchAsync(async () => {
  // await fetch()
  // // })

  return computed(() =>
    rxFreeServiceProduct.value.find((item) => item.masterKey === 'rx_services'),
  )
}

export default useRxFreeServiceProduct
